export default {
  Menu: [
    {
      name: "Sales",
      icon: "mdi-cash-register",
      divider: false,
      permission: 130,
      children: [
        {
          name: "Sales Dashboard",
          icon: "mdi-view-dashboard",
          route: { name: "SalesDashboardView" },
          divider: false,
          permission: 102,
        },
        {
          name: "Open Invoices",
          icon: "mdi-file-document-outline",
          route: { name: "SalesOpenInvoicesView" },
          divider: false,
          permission: 103,
        },
        {
          name: "Paid Invoices",
          icon: "mdi-file-document-check-outline",
          route: { name: "SalesPaidInvoicesView" },
          divider: false,
          permission: 104,
        },
        {
          name: "Converted Orders",
          icon: "mdi-cart-check",
          route: { name: "SalesConvertedOrdersView" },
          divider: false,
          permission: 105,
        },
        {
          name: "Processing Orders",
          icon: "mdi-clock-outline",
          route: { name: "SalesProcessingOrdersView" },
          divider: false,
          permission: 106,
        },
         {
          name: "Pending Deals",
          icon: "mdi-handshake",
          route: { name: "SalesPendingDealsView" },
          divider: false,
          permission: 125,
        },
        {
          name: "Paid GDrives Deals",
          icon: "mdi-google-drive",
          route: { name: "PaidDrivesDealsView" },
          divider: false,
          permission: 137,
        },
        // {
        //   name: "Customers",
        //   icon: "mdi-handshake-outline",
        //   route: { name: "SalesCustomersView" },
        //   divider: false,
        //   permission: 0,
        // },
      ],
    },
    {
      name: "Calendar",
      icon: "mdi-calendar-month",
      route: { name: "CalendarView" },
      divider: false,
      permission: 57,
    },
     {
      name: "Calendar Alerts",
      icon: "mdi-calendar-alert",
      route: { name: "CalendarAlertsView" },
      divider: false,
      permission: 183,
      count: true,
    },
    {
      name: "Tasks",
      icon: "mdi-calendar-check",
      route: { name: "TaskBrowseView" },
      divider: false,
      count: true,
      permission: 100,
    },
     {
      name: "QA Requests",
      icon: "mdi-check-decagram",
      route: { name: "TQCRequestsBrowseView" },
      divider: false,
      count: true,
      permission: 119,
    },
     {
      name: "Customer Details",
      icon: "mdi-account-multiple-plus",
      route: { name: "CustomerDetailsRequestBrowseView" },
      divider: false,
      count: true,
      permission: 121,
    },
    {
      name: "Technician Calendar",
      icon: "mdi-calendar-account",
      route: { name: "SalesPersonCalendarView" },
      divider: false,
      permission: 69,
    },
     {
      name: "Unpaid Customers",
      icon: "mdi-account-alert",
      route: { name: "UnpaidCustomerBrowseView" },
      divider: false,
      permission: 128,
    },
     {
      name: "Unpaid Technicians",
      icon: "mdi-account-credit-card-outline",
      route: { name: "UnpaidTechnicianBrowseView" },
      divider: false,
      permission: 129,
    },
     {
      name: "Technician FAQs",
      icon: "mdi-frequently-asked-questions",
      route: { name: "TechnicianFAQBrowseView" },
      divider: false,
      permission: 142,
    },
    {
      name: "Sales Report",
      icon: "mdi-finance",
      route: { name: "ReportBrowseView" },
      divider: false,
      permission: 68,
    },
    {
      name: "Income Report",
      icon: "mdi-cash-multiple",
      route: { name: "IncomeReportBrowseView" },
      divider: false,
      permission: 82,
    },
    {
      name: "Invoices",
      icon: "mdi-file-document-outline",
      route: { name: "InvoiceBrowseView" },
      divider: false,
      count: true,
      permission: 31,
    },
    {
      name: "Admin Invoices",
      icon: "mdi-file-document-outline",
      route: { name: "AdminInvoiceBrowseView" },
      divider: false,
      count: true,
      permission: 34,
    },
    {
      name: "Bookings",
      icon: "mdi-book-clock",
      route: { name: "BookingBrowseView" },
      divider: false,
      count: true,
      permission: 58,
    },
    {
      name: "Parcels",
      icon: "mdi-package-variant",
      route: { name: "ParcelBrowseView" },
      divider: false,
      count: true,
      permission: 180,
    },
    {
      name: "Pre-Orders",
      icon: "mdi-cart-outline",
      route: { name: "PreOrderBrowseView" },
      divider: false,
      count: true,
      permission: 202,
    },
    {
      name: "Tape Estimates",
      icon: "mdi-camera-outline",
      route: { name: "TapeEstimateBrowseView" },
      divider: false,
      permission: 223,
    },
    {
      name: "Orders",
      icon: "mdi-cart-outline",
      route: { name: "OrderBrowseView" },
      divider: false,
      count: true,
      permission: 43,
    },
    {
      name: "Stocks",
      icon: "mdi-cart-arrow-up",
      route: { name: "ProductStockBrowseView" },
      divider: false,
      permission: 61,
    },
    {
      name: "Stock Requests",
      icon: "mdi-cart-arrow-down",
      route: { name: "ProductStockHistoryBrowseView" },
      divider: false,
      permission: 76,
    },
    {
      name: "Stock Movement Log",
      icon: "mdi-swap-horizontal",
      route: { name: "ProductStockLogBrowseView" },
      divider: false,
      permission: 78,
    },
    {
      name: "Assets Overview",
      icon: "mdi-chart-tree",
      route: { name: "TechnicianAssetOverviewView" },
      divider: false,
      permission: 182,
    },
    {
      name: "Assets",
      icon: "mdi-puzzle-outline",
      route: { name: "AssetBrowseView" },
      divider: false,
      permission: 150,
    },
      {
      name: "Admin Assets",
      icon: "mdi-puzzle-outline",
      route: { name: "AdminAssetBrowseView" },
      divider: false,
      permission: 156,
    },
     {
      name: "Contracts",
      icon: "mdi-file-sign",
      route: { name: "ContractsBrowseView" },
      divider: false,
      permission: 159,
    },
    {
      name: "Enhancements",
      icon: "mdi-lightbulb-on-outline",
      route: { name: "EnhancementRequestBrowseView" },
      divider: false,
      permission: 93,
      count: true,
    },
    {
      name: "Audio Split",
      icon: "mdi-cassette",
      route: { name: "AudioSplitRequestBrowseView" },
      divider: false,
      permission: 135,
      count: true,
    },
     {
      name: "New Deals",
      icon: "mdi-handshake-outline",
      route: { name: "NewDealBrowseView" },
      divider: false,
      permission: 133,
    },
    {
      name: "Deals",
      icon: "mdi-handshake",
      route: { name: "DealBrowseView" },
      divider: false,
      permission: 37,
    },
    {
      name: "Transactions",
      icon: "mdi-swap-horizontal",
      route: { name: "WiseTransactionBrowseView" },
      divider: false,
      permission: 39,
    },
    {
      name: "Credits",
      icon: "mdi-swap-horizontal",
      route: { name: "WiseCreditBrowseView" },
      divider: false,
      permission: 39,
    },
    {
      name: "Reviews",
      icon: "mdi-message-draw",
      route: { name: "ReviewBrowseView" },
      divider: true,
      permission: 50,
    },
    {
      name: "Admins",
      icon: "mdi-account-tie",
      route: { name: "AdminBrowseView" },
      divider: false,
      permission: 2,
    },
    {
      name: "Technicians",
      icon: "mdi-video-account",
      route: { name: "TechnicianBrowseView" },
      divider: false,
      permission: 6,
    },
    {
      name: "Users",
      icon: "mdi-account",
      route: { name: "UserBrowseView" },
      divider: false,
      permission: 10,
    },
    {
      name: "Delivery Persons",
      icon: "mdi-truck-delivery",
      route: { name: "DeliveryPersonBrowseView" },
      divider: false,
      permission: 189,
    },
    {
      name: "Stall Persons",
      icon: "mdi-store",
      route: { name: "StallPersonBrowseView" },
      divider: false,
      permission: 205,
    },
     {
      name: "Testify Users",
      icon: "mdi-account-switch",
      route: { name: "QuizUserBrowseView" },
      divider: false,
      permission: 110,
    },
      {
      name: "ClockWise Users",
      icon: "mdi-timer-cog",
      route: { name: "ClockWiseUserBrowseView" },
      divider: false,
      permission: 145,
    },
     {
      name: "ClockWise Settings",
      icon: "mdi-timer-settings",
      route: { name: "ClockwiseSettingBrowseView" },
      divider: false,
      permission: 162,
    },
    {
      name: "Wise Users",
      icon: "mdi-account-cash",
      route: { name: "WiseUserBrowseView" },
      divider: false,
      permission: 39,
    },
    {
      name: "Wise Jars",
      icon: "mdi-pail-plus",
      route: { name: "WiseJarBrowseView" },
      divider: true,
      permission: 54,
    },
    {
      name: "Customers",
      icon: "mdi-account-group",
      route: { name: "CustomerBrowseView" },
      divider: false,
      permission: 107,
    },
    {
      name: "Customer Orders",
      icon: "mdi-package-variant-closed",
      route: { name: "CustomerOrderBrowseView" },
      divider: true,
      permission: 226,
    },
    {
      name: "Roles",
      icon: "mdi-account-cog",
      route: { name: "RoleBrowseView" },
      divider: false,
      permission: 14,
    },
    {
      name: "Products",
      icon: "mdi-sitemap",
      route: { name: "ProductBrowseView" },
      divider: false,
      permission: 23,
    },
    //   {
    //   name: "Technician Products",
    //   icon: "mdi-sitemap",
    //   route: { name: "TechnicianProductBrowseView" },
    //   divider: false,
    //   permission: 23,
    // },
    {
      name: "Locations",
      icon: "mdi-map-marker-multiple",
      route: { name: "LocationBrowseView" },
      divider: false,
      permission: 27,
    },
    {
      name: "Location Pages",
      icon: "mdi-file-document-edit-outline",
      route: { name: "LocationPageBrowseView" },
      divider: false,
      permission: 219,
    },
    {
      name: "Poster Locations",
      icon: "mdi-map-marker-path",
      route: { name: "PosterLocationBrowseView" },
      divider: false,
      permission: 194,
    },
     {
      name: "Cities",
      icon: "mdi-city",
      route: { name: "CityBrowseView" },
      divider: false,
      permission: 185,
    },
     {
      name: "links",
      icon: "mdi-link-variant",
      route: { name: "LinkBrowseView" },
      divider: false,
      permission: 216,
    },
    {
      name: "Countries",
      icon: "mdi-earth",
      route: { name: "CountryBrowseView" },
      divider: false,
      permission: 6,
    },
    {
      name: "Utils",
      icon: "mdi-tools",
      route: { name: "UtilBrowseView" },
      divider: false,
      permission: 46,
    },
    {
      name: "Monthly Overheads",
      icon: "mdi-calendar-multiple",
      route: { name: "MonthlyOverheadBrowseView" },
      divider: false,
      permission: 171,
    },
    {
      name: "FAQs",
      icon: "mdi-help-circle",
      route: { name: "FAQBrowseView" },
      divider: false,
      permission: 139,
    },
    {
      name: "Shops",
      icon: "mdi-storefront",
      route: { name: "ShopBrowseView" },
      divider: false,
      permission: 177,
    },
     {
      name: "Stall",
      icon: "mdi-store",
      route: { name: "StallBrowseView" },
      divider: false,
      permission: 210,
    },
    {
      name: "File Types",
      icon: "mdi-file",
      route: { name: "FileTypeBrowseView" },
      divider: false,
      permission: 89,
    },
     {
      name: "Asset Types",
      icon: "mdi-format-list-bulleted-type",
      route: { name: "AssetTypeBrowseView" },
      divider: false,
      permission: 164,
    },
   {
      name: "Service Types",
      icon: "mdi-cog-outline",
      route: { name: "ServiceTypeBrowseView" },
      divider: false,
      permission: 198,
    },
     {
      name: "Question Categories",
      icon: "mdi-file-question",
      route: { name: "QuestionCategoryBrowseView" },
      divider: false,
      permission: 115,
    },
    {
      name: "Mail Templates",
      icon: "mdi-email",
      route: { name: "MailTemplateBrowseView" },
      divider: false,
      permission: 64,
    },
    {
      name: "Stall Activity",
      icon: "mdi-store-clock",
      route: { name: "StallActivityBrowseView" },
      divider: false,
      permission: 213,
    },
    {
      name: "Activity logs",
      icon: "mdi-table-clock",
      route: { name: "ActivityLogBrowseView" },
      divider: true,
      permission: 17,
    },
     {
      name: "Trusted Fixers",
      icon: "mdi-shield-check",
      divider: false,
      permission: 127,
      children: [
        {
          name: "Dashboard",
          icon: "mdi-view-dashboard",
          route: { name: "TFDashboardView" },
          divider: false,
          permission: 127,
        },
        {
          name: "Technicians",
          icon: "mdi-video-account",
          route: { name: "TFTechnicianBrowseView" },
          divider: false,
          permission: 127,
        },
        {
          name: "Customers",
          icon: "mdi-account-group",
          route: { name: "TFCustomerBrowseView" },
          divider: false,
          permission: 127,
        },
         {
          name: "Support Requests",
          icon: "mdi-lifebuoy",
          route: { name: "TFSupportRequestBrowseView" },
          divider: false,
          permission: 127,
        },
        {
          name: "Technician Skills",
          icon: "mdi-star-circle-outline",
          route: { name: "TFSkillBrowseView" },
          divider: true,
          permission: 127,
        },
         {
          name: "Free hour Applications",
          icon: "mdi-clock-fast",
          route: { name: "TFFreeHourApplicationBrowseView" },
          divider: false,
          permission: 127,
        },
        {
          name: "Utils",
          icon: "mdi-tools",
          route: { name: "TFUtilBrowseView" },
          divider: false,
          permission: 127,
        },
        {
          name: "Package Types",
          icon: "mdi-package-variant-closed",
          route: { name: "TFPackageTypeBrowseView" },
          divider: true,
          permission: 127,
        },
      ],
    },
  ],
};
